/* Vendor CSS */
import 'swiper/css/bundle';

/* Vendor JS */
import Swiper from 'swiper/bundle';

/* Swiper init */
const swiperEl = document.querySelector('.swiper');
if (swiperEl) {
  new Swiper('.swiper', {
    autoplay: {
      delay: 12000,
      disableOnInteraction: false,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
}
